import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { ReportSelfPage } from './self/report-self.component';
import { ReportNetworkPage } from './network/report-network.component';

let moduleName = 'report';

export const report: Routes = [
  {
    path: `${moduleName}`,
    component: ReportSelfPage,
    title: 'Mis reportes.',
    canActivate: [authGuard, hasPermissionsGuard(['report_access'])],
  },
  {
    path: `${moduleName}/network`,
    component: ReportNetworkPage,
    title: 'Reportes generales de mi red.',
    canActivate: [authGuard, hasPermissionsGuard(['report_access'])],
  },
];
